import styled from 'styled-components';

export const Container = styled.div`
  max-width: 1160px;
  margin: 0 auto;

  .live-stage {
    display: flex;
    align-items: stretch;
    gap: 16px;
    margin-bottom: 16px;
  }

  .live-video {
    flex: 1 1 auto;
    min-width: 0;
  }

  .live-chat {
    flex: 0 0 340px;
    display: flex;
    flex-direction: column;
    border: 1px solid #ced4da;
    border-radius: 8px;
    overflow: hidden;
    background: #fff;
  }

  .live-chat iframe {
    display: block;
    width: 100%;
    flex: 1 1 auto;
    min-height: 380px;
    border: 0;
  }

  .chat-comment-link {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 9px;
    font-size: 0.85rem;
    font-weight: 600;
    color: #007bff;
    border-top: 1px solid #ced4da;
    background: #fff;
  }

  .chat-comment-link:hover {
    background: #f0f7ff;
    color: #0062cc;
  }

  .chat-comment-link .material-icons {
    font-size: 16px;
  }

  @media (max-width: 992px) {
    .live-stage {
      flex-direction: column;
    }

    .live-chat {
      flex-basis: auto;
      height: 460px;
    }
  }

  .live-header-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin: 16px 0 14px;
  }

  .live-title {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 1.15rem;
    font-weight: 700;
    color: #212529;
    min-width: 0;
  }

  .live-title .material-icons {
    color: #dc3545;
    font-size: 20px;
    flex-shrink: 0;
  }

  .minimize-btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background: #fff;
    border: 1px solid #ced4da;
    color: #21354a;
    font-size: 0.85rem;
    font-weight: 600;
    padding: 6px 12px;
    border-radius: 6px;
    cursor: pointer;
    flex-shrink: 0;
  }

  .minimize-btn:hover {
    background: #f5f6f7;
  }

  .minimize-btn .material-icons {
    font-size: 16px;
  }

  @media (max-width: 576px) {
    .live-title {
      font-size: 1rem;
    }

    .minimize-btn span,
    .minimize-btn {
      font-size: 0.8rem;
    }
  }

  .watch-on-youtube {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 0.85rem;
    color: #007bff;
    margin-bottom: 14px;
  }

  .watch-on-youtube:hover {
    color: #0062cc;
    text-decoration: underline;
  }

  .watch-on-youtube .material-icons {
    font-size: 16px;
  }

  .live-card {
    border: 1px solid #ced4da;
    border-radius: 8px;
    padding: 18px 20px;
  }

  .badges {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-bottom: 12px;
  }

  .badge-pill {
    background: #28a745;
    color: #fff;
    font-size: 0.7rem;
    font-weight: 700;
    padding: 2px 7px;
    border-radius: 4px;
  }

  .live-speaker {
    font-size: 0.85rem;
    color: #6c757d;
    margin-bottom: 10px;
  }

  .live-description {
    font-size: 0.95rem;
    color: #444;
    white-space: pre-line;
  }

  .empty-state {
    text-align: center;
    color: #888;
    padding: 70px 20px;
  }

  .empty-state .material-icons {
    font-size: 60px;
    color: #ccc;
    margin-bottom: 14px;
  }

  .loading-wrapper {
    display: flex;
    justify-content: center;
    padding: 70px 0;
  }
`;
